<template>
    <div
        @click="$emit('selectMedia',media)"
        :class="{'text-secondary': media.local, 'text-primary': !media.local}"
        class="cursor-pointer">
      <q-icon :name="$utils.contentIcon(media.contentType)" />
      {{media.name}}
      <small v-if="media.file_size">({{media.file_size | formatSize}})</small>
    </div>
</template>

<script>
import { QIcon } from 'quasar';

export default {
  components: { QIcon },
  props: {
    media: {
      type: Object,
      required: true,
    },
  },
  name: 'media-thumb',
  computed: {},
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/media-thumb.vue